import { useState, useRef, useEffect, useCallback } from 'react'
import { Box } from './'

export const LoadMoreRows = ({ rows, onLoadRows, loadIncrement }) => {
  const loadMoreRef = useRef()
  const [loading, setLoading] = useState(false)
  const [lastRowCount, setLastRowCount] = useState()

  const loadMore = useCallback(async () => {
    if((lastRowCount === rows.length || rows.length % loadIncrement !== 0)) {
      return
    }
    setLastRowCount(rows.length)
    setLoading(true)
    await onLoadRows(rows.length, loadIncrement)
    setLoading(false)
  }, [rows, onLoadRows, loadIncrement, lastRowCount])

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if(entry.intersectionRatio === 1) {
        loadMore()
      }
    })
    const loader = loadMoreRef.current
    if (loader) observer.observe(loadMoreRef.current)
    return () => {
      if (loader) observer.unobserve(loader)
    }
  }, [loadMore])

  return <Box justifyContent="center" ref={loadMoreRef}>
    {loading && <img height={loading ? 200 : 0} src="https://www.podandhive.com/assets/shivoo/gifs/three-stacked-shapes.gif" alt="Loading more" />}
  </Box>
}